import { AxiosRequestConfig } from 'axios'
import axios from './withAxios'
import PagedResult, { emptyPagedResult } from '../interfaces/pagedResult'

type PagedGetOptions = {
  page?: number
  pageSize?: number
  pesquisa?: string
} & AxiosRequestConfig

const normalizePagedResult = <T,>(data: any, page: number, pageSize: number): PagedResult<T> => {
  if (data === '' || data == null) {
    return emptyPagedResult<T>(page, pageSize)
  }

  const items = data.items ?? data.Items ?? []
  return {
    items: Array.isArray(items) ? items : [],
    page: data.page ?? data.Page ?? page,
    pageSize: data.pageSize ?? data.PageSize ?? pageSize,
    totalCount: data.totalCount ?? data.TotalCount ?? 0,
    totalPages: data.totalPages ?? data.TotalPages ?? 0,
  }
}

/**
 * Fetches a paginated list from GET /recurso or GET /recurso/search?pesquisa=
 */
const pagedGet = async <T,>(
  resource: string,
  { page = 1, pageSize = 20, pesquisa, params, ...config }: PagedGetOptions = {}
): Promise<PagedResult<T>> => {
  const base = resource.replace(/^\//, '').replace(/\/$/, '')
  const url = pesquisa ? `${base}/search` : base

  const response = await axios.get(url, {
    ...config,
    params: {
      ...params,
      page,
      pageSize,
      ...(pesquisa ? { pesquisa } : {}),
    },
  })

  return normalizePagedResult<T>(response?.data, page, pageSize)
}

export default pagedGet
export { normalizePagedResult }
